import React, { Component } from 'react'
import {
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Checkbox,
  ListItemText,
} from '@material-ui/core'
import PropType from 'prop-types'
import ArrowIcon from '@material-ui/icons/ArrowDropDown'
import CircularProgress from '@material-ui/core/CircularProgress'

class MultiSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.value,
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.value !== prevState.value) {
      this.setState({
        value: this.props.value,
      })
    }
  }

  onChangeValue = event => {
    const { value: values } = this.state
    const { value } = event.target
    const { innerText } = event.currentTarget
    let checkObj
    let existItem
    let newArr = []
    let resArr = []

    if (values && values.length > 0) {
      newArr = [...values]
      existItem = newArr.find(({ name }) => name === innerText)
      checkObj = existItem && Object.keys(existItem)
    }

    if (checkObj && checkObj.length > 0) {
      resArr = newArr.filter(({ name }) => name !== existItem.name)
    } else {
      resArr = [...resArr, ...value]
    }

    this.setState(
      {
        value: resArr,
      },
      () => this.props.onChange(resArr),
    )
  }

  getRenderValue = () => {
    const { value } = this.props

    return value.map(item => item.name).join(', ')
  }

  showRightIcon = () => {
    const { loader, SelectIcon } = this.props
    const checkIcon = !SelectIcon ? <ArrowIcon /> : <SelectIcon />

    return (
      <span className="select-loader">
        {loader ? <CircularProgress size={20} /> : checkIcon}
      </span>
    )
  }

  isSelected(item) {
    const { value } = this.props

    return value.some(({ name }) => name === item.name)
  }

  render() {
    const {
      name,
      label,
      disabled,
      disabledItem,
      data,
      value,
      autoWidth,
      meta,
      input,
      disableUnderline,
      MenuProps,
      onClose,
    } = this.props

    return (
      <FormControl
        component="div"
        fullWidth
        className="select-filter multi-select">
        <InputLabel>{label}</InputLabel>
        <Select
          meta={meta}
          input={input}
          multiple
          id={name}
          name={name}
          disabled={disabled}
          autoWidth={autoWidth}
          value={value}
          onChange={this.onChangeValue}
          onClose={onClose}
          renderValue={this.getRenderValue}
          IconComponent={this.showRightIcon}
          disableUnderline={disableUnderline}
          MenuProps={MenuProps}>
          {data.map(item => (
            <MenuItem
              className="multi-select-item"
              disabled={disabledItem}
              key={item.name}
              value={item}>
              <Checkbox
                href={null}
                color="primary"
                checked={this.isSelected(item)}
              />
              <ListItemText primary={item.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  }
}

export default MultiSelect

MultiSelect.defaultProps = {
  value: [],
  data: [],
  label: '',
  onChange: value => value,
}

MultiSelect.propTypes = {
  name: PropType.string.isRequired,
  data: PropType.array,
  value: PropType.array,
  label: PropType.string,
  onChange: PropType.func,
}
